import { useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Check, CheckCheck, Clock, PhoneOff, Send } from "lucide-react";
import { api, errMsg, fdate } from "@/lib/api";
import { useFetch } from "@/lib/hooks";
import { PageHeader, SimBadge, Empty, Loading, LiveIndicator } from "@/components/common";

const WA = {
  queued: { icon: Clock, label: "En cola", cls: "text-muted-foreground" },
  sent: { icon: Check, label: "Enviado", cls: "text-muted-foreground" },
  delivered: { icon: CheckCheck, label: "Entregado", cls: "text-muted-foreground" },
  read: { icon: CheckCheck, label: "Leído", cls: "text-sky-600" },
  sin_numero: { icon: PhoneOff, label: "Solo en app (sin WhatsApp)", cls: "text-amber-700" },
};

export default function Notifications() {
  const n = useFetch("/notifications/mine", { poll: 3000 });
  useEffect(() => { api.post("/notifications/read-all").catch(() => {}); }, [n.data?.items?.length]);
  const test = async () => {
    try { await api.post("/notifications/test"); toast.success("Mensaje de prueba enviado"); n.reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="max-w-3xl">
      <PageHeader eyebrow="Omnicanalidad" title="Notificaciones" subtitle="Confirmaciones y cambios de estatus enviados a tu WhatsApp, con acuse de entrega en tiempo real."
        actions={<><SimBadge label="WHATSAPP SIMULADO" /><Button variant="outline" size="sm" onClick={test} data-testid="notifications-test-button"><Send className="h-3.5 w-3.5 mr-1" />Probar canal</Button></>} />
      <div className="flex items-center justify-between mb-3 text-sm">
        <span className="text-muted-foreground">WhatsApp: <span className="font-mono text-foreground" data-testid="notifications-phone">{n.data?.phone || "no configurado (menú de usuario)"}</span></span>
        <LiveIndicator lastSync={n.lastSync} />
      </div>
      <Card className="bg-[#ECE5DD] border-0"><CardContent className="p-4 space-y-3 min-h-[300px]" data-testid="notifications-list">
        {n.loading ? <Loading /> : !n.data?.items?.length ? <div className="bg-white rounded-lg"><Empty title="Sin notificaciones" hint="Crea un reporte o realiza un pago para recibir mensajes." /></div> : n.data.items.map((m) => {
          const s = WA[m.wa_status] || WA.queued;
          return (
            <div key={m.notif_id} className="wa-bubble bg-white p-3 max-w-[90%] shadow-sm fade-up" data-testid={`notification-${m.notif_id}`}>
              <div className="text-sm font-semibold">{m.title}</div>
              <div className="text-sm whitespace-pre-line">{m.body}</div>
              <div className="flex items-center justify-end gap-1.5 mt-1 text-[11px]">
                <span className="text-muted-foreground">{fdate(m.created_at)}</span>
                <span className={`inline-flex items-center gap-0.5 ${s.cls}`} data-testid="notification-wa-status"><s.icon className="h-3.5 w-3.5" />{s.label}</span>
              </div>
            </div>
          );
        })}
      </CardContent></Card>
    </div>
  );
}
